<!--<button (click)="log()">log</button>-->
<csv-upload
    *ngIf="showCsvUploadDialog"
    (keydown)="onKeydown($event)"
    [enableCropper]="true"
    [fileMaxSizeInMB]="fileMaxSizeInMB"
    uploadType="Single"
    (uploadSuccess)="csvUploadSuccessHandler($event)"
    (uploadError)="csvUploadErrorHandler($event)"
    (uploadFail)="csvUploadFailHandler($event)"
    (validationError)="csvValidationErrorHandler($event)"
    [documentType]="branch"
>
</csv-upload>
<div [ngClass]="{ 'middle-layer-for-page-disable': showCsvUploadDialog }"></div>

<mat-card class="hierarchy-config-container-card">
    <div class="settings-heading">Organizational Hierarchy Structure Setup</div>
    <hierarchy-setup
        [activeCustomRoleNames]="activeCustomRoleNames"
        style="margin-bottom: 32px;"
        (setHierarchyLevels)="setHierarchyLevels($event)"
        [permenatlyHideMainButtonSet]="isLevelSetUpButtonSetHidden"
        (sideSheetOpenStatus)="sideSheetOpenStatus($event)"
    >
    </hierarchy-setup>
</mat-card>
